module.exports = __webpack_public_path__ + "static/img/SZ.b7143147.png";